<template>
  <div class="product_inf" style="">
    <card
      title="湾区认证信息">
      <!--            <div style="width: 100%;overflow: hidden;padding:1rem 2rem 0.6rem 1.8rem;">-->
      <!--              <a-carousel autoplay>-->
      <!--                <div v-for="(img,index) in list" style="width: 100%" :key="index">-->
      <!--                  <img :src="img" style="width: 100%"/>-->
      <!--                </div>-->
      <!--              </a-carousel>-->
      <!--            </div>-->
      <div class="product_inf_content" style="padding:0 2rem 0.6rem 1.8rem;">
        <span class="inlineblock width100 yellowfont minfont widthStyle">认证项目：{{certificationPrograms }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">产品区块链唯一编号： {{theBlockchainNumberOfTheProduct }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">获证组织/认证委托人：{{certifiedPrincipals }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">生产基地：{{productionBase }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">证书有效期：{{CertificateExpirationStartDate }}~{{CertificateExpirationEndDate}}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">获证产品名称：{{certificationPrograms }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">认证机构：{{certificationBodies }}</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle">认证依据：</span>
        <span class="inlineblock width100 yellowfont minfont widthStyle" v-html="basisForCertification"></span>
        <span class="inlineblock width100 yellowfont minfont ">
          <span v-if="certificateStatusText" style="color: red">{{ certificateStatusText }}</span>
          <template v-else>认证证书：<span style="color: red" @click="viewImg(Certifications)"> 查看</span></template>
        </span>
      </div><!--滑动门背景增加代码-->
    </card>
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'
  import PreviewModal from './PreviewModal'
  import { CertificateAbnormalStatusList, isCertificateAbnormal } from '@/enums/CertificateStatusEnums'

  export default {
    name: 'AuthenticationInformation',
    components: { PreviewModal, card },
    props: {
      theBlockchainNumberOfTheProduct: {
        type: String,
        default: ''
      },
      certifiedPrincipals: {
        type: String,
        default: ''
      },
      productionBase: {
        type: String,
        default: ''
      },
      CertificateExpirationStartDate: {
        type: String,
        default: ''
      },
      CertificateExpirationEndDate: {
        type: String,
        default: ''
      },
      certificationPrograms: {
        type: String,
        default: ''
      },
      certificationBodies: {
        type: String,
        default: ''
      },
      basisForCertification: {
        type: String,
        default: ''
      },
      Certifications: {
        type: String,
        default: ''
      },
      certificateStatus: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        blockChainCode: '',
        list: [
          require('@assets/湾区认证证书.png')
        ],
        reportData: [
          {
            name: '土壤环境检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '肥药检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '种子检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '过程检测报告',
            img: require('@assets/text_book.png')
          }
        ]
      }
    },
    created() {
      this.blockChainCode = this.$route.query.blockChainCode || ''
    },
    computed: {
      certificateStatusText() {
        if (!isCertificateAbnormal(this.certificateStatus)) {
          return ''
        }
        const item = CertificateAbnormalStatusList.find(i => i.value === this.certificateStatus)
        if (!item) {
          return ''
        }
        return `证书状态：${item.label}`
      }
    },
    methods: {
      initData() {
      },
      loadData() {
      },
      viewImg(url) {
        // 预览静态图片
        this.$refs.imageModal.show(url)
      }
    }
  }
</script>

<style lang="less" scoped>
.widthStyle {
  width: 18rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.bg_top {
  width: 100%;
  height: 2rem;
  background: url(../../../assets/card/bg_top.gif);
  background-size: 100% 100%;
}

.bg_con {
  width: 100%;
  height: 100%;
  padding: 0 0.8rem 0 1.1rem;
  background: url(../../../assets/card/bg_con.png) repeat-y;
  background-size: 100%;
}

.bg_bottom {
  width: 100%;
  height: 3rem;
  background: url(../../../assets/card/bg-bottom.png);
  background-size: 100% 100%;
  margin-top: -1rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>

